import { ScreenElementsStateProps } from '../states/ScreenElementsState'

export function getMapOverlayHorizontalOffset(screenElementsState: ScreenElementsStateProps): number {
  const hasOpenPanels =
    screenElementsState.drawer ||
    screenElementsState.toolPanel ||
    screenElementsState.featureInfoPanel ||
    screenElementsState.chat

  if (!hasOpenPanels) {
    return 0
  }

  return (screenElementsState.boundsDefaultPadding.left - screenElementsState.boundsDefaultPadding.right) / 2
}
